import styled from "styled-components";
import LogoIcon from "./img/hzs_logo.png";

const Contacts2 = () => {
  return (
    <StyledContacts>
      <a className="logo" href="https://hozesolutions.com/">
        <img src={LogoIcon} alt="logo" />
      </a>
    </StyledContacts>
  );
};

const StyledContacts = styled.div`
  max-width: 350px;
  position: absolute;
  left: 20px;
  bottom: 20px;
  z-index: 1000;

  img {
    width: 100%;
  }

  @media screen and (max-width: 720px) {
    left: 20px;
    bottom: 20px;
  }

  @media screen and (max-width: 540px) {
    left: 50%;
    transform: translateX(50%);
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
`;

export default Contacts2;
